module.exports = "/_next/static/images/0c0664a41b293aece817fda61b69f055-roxinho-scene-card-with-phone-lg@1x.jpg";